export default __webpack_public_path__ + "static/media/mongodb.1d06b1a7.svg";